import React from 'react';
import Modal from '../Modal';

const AdviserModal = ({notifications, currentUserId, handleModalClose}) => {

  const updateNotification = (notificationId) => {
    $.ajax({
      type: 'put',
      url: `/users/${currentUserId}/notifications/${notificationId}/update_notification`,
      success: function(res) {
        handleModalClose(notifications);
        window.location.href = notifications[0].url;
      }
    })
  }

  return (
    <div data-reveal className='reveal-modal' id='adviser-alert-modal'>
      <div className='modal-body'>
        <div className='modal-close'>
          <a href='#' className='cancel-modal'>
            <img src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>
      </div>
      <div className='modal-content'>
        <h4 className='title'>{notifications[0].title}</h4>
        <div className="adviser-blurb">
          <p>Cureus was founded with the goal of breaking down barriers to publication and embracing the medical community of authors and peer reviewers to advance medical knowledge. Mentors and colleagues often have excellent advice and feedback for authors, but should not serve as peer reviewers due to potential conflicts of interest per COPE guidelines.</p>
          <p>That’s where Advisers come in. During the initial manuscript submission, authors invite at least five colleagues or mentors to provide feedback in an advisory capacity.</p>
          <p>Advisers are not considered peer reviewers and their comments are not considered part of the formal peer review process. As a result, independent Cureus editors (associate editors) do not need to take their feedback into consideration during their editorial review.</p>
        </div>
        <h4 className='message'>{notifications[0].message}</h4>
        <div className='notifications-container'>
          {notifications.map((notification, index) => {
            return (
              <div key={index} className='notification'>
                <div className='article-title'>{notification.article_title}</div>
                <div className='article-link btn'>
                  <a className='button special small' onClick={()=> updateNotification(notification.id)}>{notification.btn_text}</a>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default AdviserModal;